import React, { useState, useEffect, useRef } from 'react';
import './Contact.css';
import 'particles.js';


function Contact() {
    const [scrollPercentage, setScrollPercentage] = useState(0);
    const contactSectionRef = useRef(null);
    

    useEffect(() => {
        // Load and apply the particles
        window.particlesJS.load('particles-js', 'assets/particles.json', function() {
            console.log('callback - particles.js config loaded');
        });
        const onScroll = () => {
            const scrollHeight = window.innerHeight + window.scrollY;
            const totalHeight = contactSectionRef.current.offsetTop + contactSectionRef.current.offsetHeight;

            if (scrollHeight > contactSectionRef.current.offsetTop && scrollHeight < totalHeight) {
                const percentageScrolled = (scrollHeight - contactSectionRef.current.offsetTop) / window.innerHeight;
                setScrollPercentage(percentageScrolled);
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        }
    }, []);

    return (
        <div className="contact-section" ref={contactSectionRef}>
         <h1 className="welcome-text" style={{color: 'white'}}>Haz magia con nosotros ya!</h1>
            <div className="contact-portfolio">
                <img className="frame frame-1" src="/images/frame-1.png" alt="Frame 1" style={{transform: `translateX(${scrollPercentage * 2550 - 3000}px)`}}/>
                <img className="frame frame-2" src="/images/frame-2.png" alt="Frame 2" style={{transform: `translateX(${scrollPercentage * 2500 - 2950}px)`}}/>
                <img className="frame frame-3" src="/images/frame-3.png" alt="Frame 3" style={{transform: `translateX(${scrollPercentage * 2450 - 2900}px)`}}/>
                <img className="frame frame-4" src="/images/frame-4.png" alt="Frame 4" style={{transform: `translateX(${scrollPercentage * 2400 - 2850}px)`}}/>
                <img className="frame frame-5" src="/images/frame-5.png" alt="Frame 5" style={{transform: `translateX(${scrollPercentage * 2350 - 2800}px)`}}/>
            </div>
            <div className='formWrapper'>
            <div className="contact-form-container">
                <form action="/submit" method="POST"> {/* You can change the action attribute as needed */}
                    <p className="welcome-text" style={{color: 'white', fontSize: '32px'}}>Dejanos un mensaje</p>
                    <input type="text" name="name" placeholder="Tu nombre" required />
                    <input type="tel" name="number" placeholder="Tu numero" required />
                    <textarea name="request" placeholder="Como podemos cambiar tu historia..." rows="5" required></textarea>
                    <button className="main-button">Send</button>
                </form>
            </div>

            </div>
            <div id="particles-js-2"></div> {/* Add this at the end of the contact-section */}
        </div>
    );
}

export default Contact;
